import { AsyncStoreItem } from '@lib';
import { PostJourneysSearchJourneyResponse } from 'src/sdk_checkin';

/**
 * CheckinSearchResult model
 */
export interface CheckinSearchResultModel {
  model: PostJourneysSearchJourneyResponse | null;
}

/**
 * PostJourneysSearchJourneyResponse model details
 */
export interface CheckinSearchResultStateDetails extends AsyncStoreItem {}

/**
 * CheckinSearchResult store state
 */
export interface CheckinSearchResultState extends CheckinSearchResultStateDetails, CheckinSearchResultModel {}

/**
 * Name of the CheckinSearchResult Store
 */
export const CHECKIN_SEARCH_RESULT_STORE_NAME = 'checkinSearchResult';

/**
 * CheckinSearchResult Store Interface
 */
export interface CheckinSearchResultStore {
  /** CheckinSearchResult state */
  [CHECKIN_SEARCH_RESULT_STORE_NAME]: CheckinSearchResultState;
}
